import { AsientoContableDetalle } from "./asiento-contable-detalle";
import { Cobro } from "./cobro";
import { Compra } from "./compra";
import { Pago } from "./pago";
import { PeriodoContable } from "./periodo-contable";
import { Retencion } from "./retencion";
import { TipoIdentificacion } from "./tipo-identificacion";
import { Venta } from "./venta";

export class AsientoContable{
    public constructor(
        public id: String = "",
        public tipo_comprobante_id: String = "",
        public periodo_contable_id: String = "",
        public codigo:String = "",
        public is_automatico: boolean = false,
        public descripcion:String = "",
        public observacion: String = "",
        public fecha_emision:String = "",
        public tipo_transaccion_contabilidad_id: String = "",
        public numero_documento:String = "",
        public total: number = 0,
        public empresa_id: String = "",
        public usuario_id:String = null,
        public status: string = "",
    
        public tipocomprobante: any = {},
        public tipotransaccion: any = {},
        public periodo: PeriodoContable = new PeriodoContable(),
        public venta: Venta = new Venta(),
        public compra: Compra = new Compra(),
        public retencion: Retencion = new Retencion(),
        public pago: Pago = new Pago(),
        public cobro: Cobro = new Cobro(),
        public detalle: Array<AsientoContableDetalle> = [],

    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/asiento-contable.ts